import React from 'react';
import { useStaticQuery, graphql } from "gatsby";
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { Paper, Grid, List, ListItem, IconButton, ListItemText, ListItemSecondaryAction } from '@material-ui/core';
import ContentsContiner from "../../components/contentContiner";
import {Twitter, GitHub, Instagram, YouTube} from '@material-ui/icons';
import { DateTime } from "luxon";

const useStyles = makeStyles((theme) => ({
  icon: {
    width: theme.spacing(25),
    height: theme.spacing(25),
    margin: '0 auto',
  },
  container: {
    padding: theme.spacing(2),
    margin: 'auto',
    maxWidth: 700,
  },
  snsIcon: {
    height: '5.0em',
    '& .MuiSvgIcon-root': {
      '&:hover': {
        color: theme.palette.secondary.main,
        fontSize: '1.8em',
      },
    },
    '& a': {
      color: theme.palette.primary.main,
    },
  },
  pixivIconLink: {
    textDecoration: 'none',
    background: "#055",  
    '&:hover': {
      textDecoration: 'none',
    }
  },
  pixivIcon: {
    fontSize: '1.8em',
    fontFamily: 'Courier',

    '&:hover': {
      fontSize: '2.0em',
      color: theme.palette.secondary.main,
    }
  },
  paper: {
    width: '100%',
    padding:'20px',
    marginTop: '40px',
  },
}));

const convertShortDate = (date: string) => {
  return DateTime.fromISO(date).setLocale('ja').toFormat('yyyy年MM月')
}

const About = () => {
  const classes = useStyles();

  const data = useStaticQuery(
    graphql`
      query {
        allMicrocmsWorks(sort: {order: DESC, fields: date}) {
          nodes {
            id
            tag
            date
            title
            linkText
            link
          }
        }
      }
    ` 
  )

  return (
    <ContentsContiner>
        <Typography variant="h3" gutterBottom>
          profile.
        </Typography>
          <Avatar src='https://pbs.twimg.com/profile_images/1588871774854213632/Tfumbj8u_400x400.jpg' alt='icon' className={classes.icon} />
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={3}
            className={classes.snsIcon}>
            <Grid item>
              <a href='https://twitter.com/meru_lotte' target='_blank' rel="noopener">
                <Twitter />
              </a>
            </Grid>
            <Grid item>
              <a href='https://www.instagram.com/meru_lotte/' target='_blank' rel="noopener">
                <Instagram />
              </a>
            </Grid>
            <Grid item>
              <a href='https://www.youtube.com/channel/UC_IGmPACvWl4Ht0GXLskJ6g' target='_blank' rel="noopener">
                <YouTube />
              </a>
            </Grid>
            <Grid item>
              <a href='https://www.pixiv.net/users/50430472'
                className={classes.pixivIconLink}
                target='_blank' rel="noopener">
                <div>
                  <Typography className={classes.pixivIcon}>P</Typography>
                </div>
              </a>
            </Grid>
          </Grid>

          <Paper elevation={1} className={classes.paper}>
          <Typography variant="caption">イラストレーター</Typography>
          <Typography variant="h6" gutterBottom>めるろって</Typography>
          <Typography variant="body1" gutterBottom paragraph>
            2021年よりフリーのイラストレーターとして活動を開始。<br/>
            少年少女とファンタジー世界を得意としています<br/>
          </Typography>
          
          <Typography variant="subtitle1" gutterBottom>作業環境</Typography>
          <Typography variant="body1" gutterBottom paragraph>
            Mac OS<br/>
            Clip Studio Paint<br/>
          </Typography>
          </Paper>

          <Paper elevation={1} className={classes.paper}>

          <Typography variant="subtitle1">Live2Dモデリング</Typography>
          <List>
            {data.allMicrocmsWorks.nodes.filter(node => node.tag == 'Live2D').map( node =>
              <ListItem key={node.id}>
                <ListItemText primary={`${convertShortDate(node.date)}  ${node.title}`} />
                {node.link &&
                  <ListItemSecondaryAction >
                    <IconButton href={node.link} target='_blank' >
                      <YouTube/>
                    </IconButton>
                  </ListItemSecondaryAction>
                }
              </ListItem>,
            )}
          </List>

          <Typography variant="subtitle1">イラスト</Typography>
          <List>
            {data.allMicrocmsWorks.nodes.filter(node => node.tag == '動画').map( node =>
              <ListItem key={node.id}>
                <ListItemText primary={`${convertShortDate(node.date)}  ${node.title}`} />
                {node.link &&
                  <ListItemSecondaryAction >
                    <IconButton href={node.link} target='_blank' >
                      <YouTube/>
                    </IconButton>
                  </ListItemSecondaryAction>
                }
              </ListItem>,
            )}
          </List>

          <Typography variant="subtitle1">展示</Typography>
          <List>
            {data.allMicrocmsWorks.nodes.filter(node => node.tag == '展示').map( node =>
              <ListItem key={node.id}>
                <ListItemText primary={`${convertShortDate(node.date)}  ${node.title}`} />
                {node.link &&
                  <ListItemSecondaryAction >
                    <IconButton href={node.link} target='_blank' >
                      <YouTube/>
                    </IconButton>
                  </ListItemSecondaryAction>
                }
              </ListItem>,
            )}
          </List>
          </Paper>
          <p></p>
    </ContentsContiner>
  );
}
export default About;
